import { systemBlack } from "../../../constants";
import { createStyledElement } from "../../../../../utils/createStyledElement";

export const ContactsPane = createStyledElement("div", {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: 20,
  width: "100%",
  maxWidth: "100%",
  flexWrap: "wrap",
  minWidth: 0,
});

export const ContactName = createStyledElement("span", {
  font: '400 16px/21px "Roboto", sans-serif',
  color: "#90989F",
});

export const ContactText = createStyledElement("span", {
  font: '400 16px/21px "Roboto", sans-serif',
  color: systemBlack,
  wordBreak: "break-word",
});

export const Link = createStyledElement("a", {
  font: '400 16px/21px "Roboto", sans-serif',
  color: "#306BF5",
  textDecoration: "none",
  wordBreak: "break-word",
});

export const CloseIconContainer = createStyledElement("div", {
  display: "flex",
  justifyContent: "flex-end",
  padding: "0 10px",
  width: "100%",
  cursor: "pointer",
});

export const CloseIcon = createStyledElement("span", {
  fontSize: 30,
  display: "inline-flex",
  alignItems: "center",
});

export const ContactUsButton = createStyledElement("span", {
  cursor: "pointer",
  font: '400 16px/21px "Roboto", sans-serif',
  color: "#306BF5",
  marginTop: 25,
});

export const Text = createStyledElement("span", {
  font: '400 14px/18px "Roboto", sans-serif',
  color: systemBlack,
  wordBreak: "break-word",
});
